import { makeVar } from '@apollo/client';
import { getLocalStorageVariable } from '../helpers/local-storage';

export const tokenVar = makeVar(getLocalStorageVariable('token'));

export const refreshTokenVar = makeVar(getLocalStorageVariable('refreshToken'));

export const tokenExpireVar = makeVar(getLocalStorageVariable('tokenExpire'));
